module.exports = __webpack_public_path__ + "static/media/mh_entrium_03.5c9a9290.png";